module.exports = __webpack_public_path__ + "img/floodfighting-20160720-03-1024x768.cef3292d.jpg";